import React from 'react';
import Layout from "../components/Layout";
import Header from "../components/Header";
import ListGroup from 'react-bootstrap/ListGroup';
import {mdiCheck, mdiCircleHalfFull, mdiInformationOutline, mdiMoonWaningCrescent, mdiWeatherSunny} from "@mdi/js";
import Icon from "@mdi/react";
import lvFlag from "../assets/languages/lv.png";
import enFlag from "../assets/languages/en.png";
import ruFlag from "../assets/languages/ru.png";
import {useManageContext} from "../App";
import {LanguagesType} from "../types/Languages";
import Button from 'react-bootstrap/Button';
import {ColorModesType} from "../types/ColorModes";
import {Link} from "react-router-dom";
import i18n from "../lang/i18n";

export default function Settings() {

    const {lang, switchTheme, colorMode, switchLang} = useManageContext();

    return (
        <Layout>
            <Header/>
            <div className="py-3 px-4">
                <h5 className="mb-3">{i18n.t('198')}</h5>
                <ListGroup>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        <Button
                            variant="link"
                            className="w-100 d-flex justify-content-between align-items-center p-0 text-decoration-none"
                            onClick={() => switchLang(LanguagesType.Latvian)}
                        >
                            <p className="mb-0">
                                <img src={lvFlag} alt="Latviešu" style={{maxHeight: 12}}/><span className="ms-2">Latviešu</span>
                            </p>
                            <div>{lang === LanguagesType.Latvian &&
                                <Icon className="text-primary" path={mdiCheck} size={.8}/>}</div>
                        </Button>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        <Button
                            variant="link"
                            className="w-100 d-flex justify-content-between align-items-center p-0 text-decoration-none"
                            onClick={() => switchLang(LanguagesType.English)}
                        >
                            <p className="mb-0">
                                <img src={enFlag} alt="English" style={{maxHeight: 12}}/>
                                <span className="ms-2">English</span>
                            </p>
                            <div>{lang === LanguagesType.English &&
                                <Icon className="text-primary" path={mdiCheck} size={.8}/>}
                            </div>
                        </Button>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        <Button
                            variant="link"
                            className="w-100 d-flex justify-content-between align-items-center p-0 text-decoration-none"
                            onClick={() => switchLang(LanguagesType.Russian)}
                        >
                            <p className="mb-0">
                                <img src={ruFlag} alt="Русский" style={{maxHeight: 12}}/>
                                <span className="ms-2">Русский</span>
                            </p>
                            <div>{lang === LanguagesType.Russian &&
                                <Icon className="text-primary" path={mdiCheck} size={.8}/>}
                            </div>
                        </Button>
                    </ListGroup.Item>
                </ListGroup>
            </div>
            <div className="py-3 px-4">
                <h5 className="mb-3">{i18n.t('2568')}</h5>
                <ListGroup>
                    <ListGroup.Item>
                        <Button
                            variant="link"
                            className="w-100 d-flex justify-content-between align-items-center p-0 text-decoration-none"
                            onClick={() => switchTheme(ColorModesType.auto)}
                        >
                            <p className="mb-0">
                                <Icon className="text-primary" path={mdiCircleHalfFull} size={.8}/>
                                <span className="ms-2">{i18n.t('2567')}</span>
                            </p>
                            <div>
                                {colorMode === ColorModesType.auto &&
                                    <Icon className="text-primary" path={mdiCheck} size={.8}/>}
                            </div>
                        </Button>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        <Button
                            variant="link"
                            className="w-100 d-flex justify-content-between align-items-center p-0 text-decoration-none"
                            onClick={() => switchTheme(ColorModesType.light)}
                        >
                            <p className="mb-0">
                                <Icon className="text-primary" path={mdiWeatherSunny} size={.8}/>
                                <span className="ms-2">{i18n.t('2570')}</span>
                            </p>
                            <div>{colorMode === ColorModesType.light &&
                                <Icon className="text-primary" path={mdiCheck} size={.8}/>}</div>
                        </Button>
                    </ListGroup.Item>
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        <Button
                            variant="link"
                            className="w-100 d-flex justify-content-between align-items-center p-0 text-decoration-none"
                            onClick={() => switchTheme(ColorModesType.dark)}
                        >
                            <p className="mb-0">
                                <Icon className="text-primary" path={mdiMoonWaningCrescent} size={.8}/>
                                <span className="ms-2">{i18n.t('2569')}</span>
                            </p>
                            <div>{colorMode === ColorModesType.dark &&
                                <Icon className="text-primary" path={mdiCheck} size={.8}/>}</div>
                        </Button>
                    </ListGroup.Item>
                </ListGroup>
            </div>
            <div className="py-3 px-4">
                <h5 className="mb-3">General</h5>
                <ListGroup>
                    <ListGroup.Item>
                        <Link
                            to="https://cloudex.eu/privacy-policy/"
                            target="_blank"
                            className="w-100 d-flex justify-content-between align-items-center p-0 text-decoration-none"
                        >
                            <p className="mb-0">
                                <Icon className="text-primary" path={mdiInformationOutline} size={.8}/>
                                <span className="ms-2">Privacy Policy</span>
                            </p>
                        </Link>
                    </ListGroup.Item>
                </ListGroup>
            </div>
        </Layout>
    )
}